import { useEffect, useState } from 'react'
import { useForm } from 'antd/es/form/Form'
import { Form, Input, Modal, Select } from 'antd'
import { SignTitle } from '@/components'
import { useReTestTask, useGetTaskDetailUseCaseStatus, useGetTaskDetailUseCaseCount } from './utils'
import styled from 'styled-components'
import { t } from '@/i18n'

export const RetestModal = props => {
  const { id, visible, onCancel, onSuccess, name } = props

  const [form] = useForm()

  const [retestTask, retestLoading] = useReTestTask()
  const [getTaskDetailUseCaseStatus, caseStatusOption] = useGetTaskDetailUseCaseStatus()
  const [getTaskDetailUseCaseCount] = useGetTaskDetailUseCaseCount()
  const [count, setCount] = useState(0)

  const [selectedStatuses, setSelectedStatuses] = useState<string[]>([])
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    if (visible) {
      form.setFieldValue('result_name', name)
      setLoading(false)
      getTaskDetailUseCaseStatus({ resultId: id })
        .then(res => {
          const caseStatus = res?.data?.list?.map(item => item.caseStatus)
          setSelectedStatuses(caseStatus)
          form.setFieldsValue({ case_status: caseStatus })
          getTaskDetailUseCaseCount({
            resultId: id,
            caseStatus: caseStatus, // 否则传选中的状态
          })
            .then(r => {
              setCount(r.data.count)
            })
            .catch(_ => {})
        })
        .catch(_ => {})
    }
  }, [visible])

  const handleStatusChange = (values: string[]) => {
    if (values.length === 0) {
      setCount(0)
      return
    }
    setSelectedStatuses(values)
    getTaskDetailUseCaseCount({
      resultId: id,
      caseStatus: values, // 否则传选中的状态
    })
      .then(r => {
        setCount(r.data.count)
      })
      .catch(_ => {})
  }

  const handleConfirm = values => {
    if (loading) {
      return
    }
    setLoading(true)
    const { result_name } = values
    retestTask({ result_id: id, result_name, case_status: selectedStatuses })
      .then(() => {
        onSuccess()
      })
      .catch(_ => {})
      .finally(() => {
        setLoading(false)
      })
  }

  const optionsMap = {
    CaseStatusExecSuccess: t('执行成功'),
    CaseStatusExecFailure: t('执行失败'),
    CaseStatusInterceptionSuccess: t('拦截成功'),
    CaseStatusInterceptionFailure: t('防护失效'),
    CaseStatusInterceptionDefenceFail: t('防护失效'),
    CaseStatusCancelValid: t('取消验证'),
    CaseStatusAlert: t('告警用例'),
    CaseStatusNotAlert: t('无告警用例'),
    CaseStatusNotExecute: t('未执行'),
  }

  return (
    <Wrapper
      width="498px"
      title={
        <SignTitle show style={{ width: '498px' }}>
          {t('任务复测')}
        </SignTitle>
      }
      centered
      onOk={form.submit}
      visible={visible}
      onCancel={onCancel}
      confirmLoading={loading}
    >
      <Form
        form={form}
        layout={'vertical'}
        onFinish={handleConfirm}
        initialValues={{ result_name: name, type: 'immediate' }}
      >
        <Form.Item
          label={t('任务名称')}
          name={'result_name'}
          rules={[
            { required: true, message: t('请输入任务名称') },
            { max: 99, message: t('任务名称最多99字') },
          ]}
        >
          <Input placeholder={t('请输入')} />
        </Form.Item>

        <Form.Item
          label={t('执行类型')}
          name={'type'}
          rules={[{ required: true, message: t('请选择执行类型') }]}
        >
          <Select placeholder={t('请选择')} disabled>
            <option value="immediate">{t('立即执行')}</option>
          </Select>
        </Form.Item>

        <Form.Item
          label={t('用例筛选')}
          name={'case_status'}
          rules={[{ required: true, message: t('请选择用例') }]}
        >
          <Select
            placeholder={t('请选择')}
            mode="multiple"
            value={selectedStatuses}
            onChange={handleStatusChange}
            maxTagCount={3}
          >
            {caseStatusOption?.map((item, i) => (
              <Select.Option key={i} value={item.caseStatus}>
                {`${optionsMap[item.caseStatus] || item.caseStatus}(${item.caseCount})`}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>

        <div>
          {t('本次用例总数：')}
          <span style={{ color: '#64BDC0' }}>{count || 0}</span>
          {t('个')}
        </div>
      </Form>
    </Wrapper>
  )
}

const Wrapper = styled(Modal)`
  .ant-modal-content {
    border-radius: 8px;
    position: relative;

    .ant-modal-close {
      width: 36px;
      height: 36px;
      background: #d8d6f4;
      box-shadow: -1px 4px 10px 0px #c7c7c7;
      border-radius: 6px;
      border: none;
      color: #4238c9;
      font-size: 16px;
      font-weight: 500;
      position: absolute;
      right: -8px;
      top: -8px;
      transition: transform 0.3s ease;

      &:hover {
        transform: translate(-18px, 18px);
        box-shadow: 0 0 0 0;
      }

      .ant-modal-close-x {
        width: 100%;
        height: 100%;
        line-height: 36px;
        text-align: center;
      }
    }

    .ant-modal-header {
      height: 56px;
      background: #f2f0ff;
      border-bottom: none;
      margin: 0;
      padding: 19px 20px;
    }
  }
`
